document.addEventListener('DOMContentLoaded', () => {
  const sfContainer = document.querySelector('#search-form-id');
  const config = {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['height']
  };

  const observer = new MutationObserver((mutationsList) => {
    const sfFrame = document.querySelector('#search-form-id iframe[id^="tlFrame"]');

    const setSFHeight = () => {
      const sfFrameHeight = sfFrame.getAttribute('height');
      sfContainer.style.height = `${sfFrameHeight}px`
    };

    for (let mutation of mutationsList) {
      if (mutation.attributeName === 'height') {
        setSFHeight();
      }
    }
  });

  observer.observe(sfContainer, config);
});
